import { combineReducers } from "redux";
import total_recording_list from "../features/admin/all_recording_list/Slice";

const AllRecordingListData = combineReducers({
  total_recording_list: total_recording_list,
});

export default AllRecordingListData;
